module.exports = __webpack_public_path__ + "img/Noctiluca-3.6dc3c9da.png";